import CardSection from './CardSection';
import InputField  from '../form/InputField';
import SelectField from '../form/SelectField';

export default function AdditionalInfoSection({ 
    data, 
    municipios,
    onChange, 
    errors 
}) {
    const municipiosOptions = Array.isArray(municipios)
        ? municipios.map(item => ({ 
            value: item.codigo,
            label: item.descripcion 
        }))
        : [];

    // Fecha de hoy en formato YYYY-MM-DD, para usar como máximo
    const today = new Date().toISOString().split('T')[0];

    return (
        <>
            <CardSection icon="info" title="Información Detallada">
                <div className="row">
                    <div className="col-md-4">
                        <InputField
                            id="fechaNacimiento"
                            label="Fecha de Nacimiento"
                            type="date"
                            value={data.fechaNacimiento || ''}
                            onChange={onChange}
                            max={today}
                            onKeyDown={e => e.preventDefault()}
                            onPaste={e => e.preventDefault()}
                            error={errors?.fechaNacimiento}
                        />
                    </div>
                    <div className="col-md-4">
                        <SelectField
                            id="lugarNacimiento"
                            label="Lugar de Nacimiento"
                            options={municipiosOptions}
                            value={data.lugarNacimiento || ''}
                            onChange={onChange}
                            error={errors?.lugarNacimiento}
                            isSearchable={true}
                        />
                    </div>
                    <div className="col-md-4">
                        <InputField
                            id="estadoCivil"
                            label="Estado Civil"
                            placeholder="Ingrese estado civil"
                            value={data.estadoCivil || ''}
                            onChange={onChange}
                            error={errors?.estadoCivil}
                        />
                    </div>
                    <div className="col-md-4">
                        <InputField
                            id="profesion"
                            label="Profesión / Oficio"
                            placeholder="Ingrese profesión"
                            value={data.profesion || ''}
                            onChange={onChange}
                            error={errors?.profesion}
                        />
                    </div>
                    <div className="col-md-4">
                        <InputField
                            id="empresa"
                            label="Empresa"
                            placeholder="Ingrese empresa"
                            value={data.empresa || ''}
                            onChange={onChange}
                            error={errors?.empresa}
                        />
                    </div>
                    <div className="col-md-4">
                        <InputField
                            id="sitioWeb"
                            label="Sitio Web"
                            placeholder="Ingrese URL"
                            value={data.sitioWeb || ''}
                            onChange={onChange}
                            error={errors?.sitioWeb}
                        />
                    </div>
                </div>
            </CardSection>

            <CardSection icon="security" title="Seguridad Social y Legal">
                <div className="row">
                    <div className="col-md-6">
                        <InputField
                            id="eps"
                            label="Información de EPS"
                            placeholder="Detalles EPS"
                            value={data.eps || ''}
                            onChange={onChange}
                            error={errors?.eps}
                        />
                    </div>
                    <div className="col-md-6">
                        <InputField
                            id="arl"
                            label="Información de ARL"
                            placeholder="Detalles ARL"
                            value={data.arl || ''}
                            onChange={onChange}
                            error={errors?.arl}
                        />
                    </div>
                    <div className="col-md-6">
                        <InputField
                            id="judicial"
                            label="Información Judicial"
                            placeholder="Detalles judiciales"
                            value={data.judicial || ''}
                            onChange={onChange}
                            error={errors?.judicial}
                        />
                    </div>
                    <div className="col-md-6">
                        <InputField
                            id="militar"
                            label="Situación Militar"
                            placeholder="Detalles situación militar"
                            value={data.militar || ''}
                            onChange={onChange}
                            error={errors?.militar}
                        />
                    </div>
                </div>
            </CardSection>
            <CardSection icon="warning" title="Contacto de Emergencia">
                <div className="row">
                    <div className="col-md-4">
                        <InputField
                            id="contactoEmergenciaNombre"
                            label="Nombre Completo"
                            placeholder="Ingrese nombre completo"
                            value={data.contactoEmergenciaNombre || ''}
                            onChange={onChange}
                            error={errors?.contactoEmergenciaNombre}
                        />
                    </div>
                    <div className="col-md-4">
                        <InputField
                            id="contactoEmergenciaProfesion"
                            label="Profesión"
                            placeholder="Ingrese profesión"
                            value={data.contactoEmergenciaProfesion || ''}
                            onChange={onChange}
                            error={errors?.contactoEmergenciaProfesion}
                        />
                    </div>
                    <div className="col-md-4">
                        <InputField
                            id="contactoEmergenciaCelular"
                            label="Celular"
                            placeholder="Ingrese número de celular"
                            value={data.contactoEmergenciaCelular || ''}
                            onChange={onChange}
                            error={errors?.contactoEmergenciaCelular}
                        />
                    </div>
                </div>
            </CardSection>

            <CardSection icon="phone" title="Contacto de Referencia">
                <div className="row">
                    <div className="col-md-4">
                        <InputField
                            id="contactoReferenciaNombre"
                            label="Nombre Completo"
                            placeholder="Ingrese nombre completo"
                            value={data.contactoReferenciaNombre || ''}
                            onChange={onChange}
                            error={errors?.contactoReferenciaNombre}
                        />
                    </div>
                    <div className="col-md-4">
                        <InputField
                            id="contactoReferenciaProfesion"
                            label="Profesión"
                            placeholder="Ingrese profesión"
                            value={data.contactoReferenciaProfesion || ''}
                            onChange={onChange}
                            error={errors?.contactoReferenciaProfesion}
                        />
                    </div>
                    <div className="col-md-4">
                        <InputField
                            id="contactoReferenciaCelular"
                            label="Celular"
                            placeholder="Ingrese número de celular"
                            value={data.contactoReferenciaCelular || ''}
                            onChange={onChange}
                            error={errors?.contactoReferenciaCelular}
                        />
                    </div>
                </div>
            </CardSection>
        </>
    );
}
